import {getRouter} from './index';

let init = false;
const pageMap = {};
function doInit() {
    const router = getRouter();
    const routes = router.getRoutes();
    routes.forEach(route => {
        if (route.meta?.name) {
            pageMap[route.meta.name] = route;
        }
    });
    init = true;
}

export function isPage(pageName, route) {
    const router = getRouter();
    const matchRoute = route || router.currentRoute.value;
    const matched = matchRoute.matched;
    if (matched && matched.length) {
        for (let i = 0; i < matched.length; i++) {
            const item = matched[i];
            if (item.meta && item.meta.name === pageName) {
                return true;
            }
        }
    }
    return false;
}

export function getPagePath(pageName) {
    if (!init) {
        doInit();
    }
    const page = pageMap[pageName];
    if (!page) {
        throw new Error(`can not found page "${pageName}"`);
    }
    return page.path;
}